import {createAction} from 'redux-actions';
import * as Constants from './constants';

export const setCurrentTransaction = createAction(Constants.SET_CURRENT_INVOICE_CODE_FOR_TRANSACTION, (datas) => ({...datas}));
export const clearState = createAction(Constants.CLEAR_CURRENT_INVOICE_CODE_FOR_TRANSACTION, () => ({}));

